import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M3.66659 0.666016C1.82564 0.666016 0.333252 2.1584 0.333252 3.99935V13.9993C0.333252 15.8403 1.82564 17.3327 3.66659 17.3327H10.9215C12.4376 17.3327 13.6666 16.1037 13.6666 14.5876C13.6666 14.1273 13.2935 13.7542 12.8333 13.7542C12.373 13.7542 11.9999 14.1273 11.9999 14.5876C11.9999 15.1832 11.5171 15.666 10.9215 15.666H3.66659C2.74611 15.666 1.99992 14.9198 1.99992 13.9993V3.99935C1.99992 3.07887 2.74611 2.33268 3.66659 2.33268H10.3824C11.2757 2.33268 11.9999 3.05688 11.9999 3.95023C11.9999 4.41046 12.373 4.78356 12.8333 4.78356C13.2935 4.78356 13.6666 4.41046 13.6666 3.95023C13.6666 2.13641 12.1962 0.666016 10.3824 0.666016H3.66659Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M6.07015 8.12222C5.60991 8.12222 5.23682 8.49532 5.23682 8.95555C5.23682 9.41579 5.60991 9.78889 6.07015 9.78889H11.0053L9.94678 10.8474C9.62135 11.1729 9.62135 11.7005 9.94678 12.0259C10.2722 12.3514 10.7999 12.3514 11.1253 12.0259L13.6064 9.54486C13.678 9.47321 13.7339 9.39175 13.774 9.3048C13.8231 9.19858 13.8505 9.08027 13.8505 8.95556C13.8505 8.80454 13.8103 8.66291 13.7401 8.54076C13.736 8.53369 13.7319 8.52669 13.7276 8.51976C13.7213 8.50957 13.7149 8.49952 13.7082 8.48963L13.6998 8.47741C13.6698 8.43469 13.6359 8.39492 13.5986 8.3586L11.1253 5.88527C10.7999 5.55984 10.2722 5.55984 9.94678 5.88527C9.62135 6.21071 9.62135 6.73835 9.94678 7.06378L11.0052 8.12222H6.07015Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}